import {
  createContext,
  type FC,
  type PropsWithChildren,
  useContext,
  useMemo,
} from 'react'

import { useGetExperiment } from '../../../experiments/hooks'
import { EXPERIMENT_NAME_ODS_VC_MODAL } from '../../../experiments/model/EXPERIMENT_NAME'
import { experimentAccessorIsVariantV1 } from '../../../experiments/model/experimentAccessor'
import { useProductPageContext } from '../../components/productPageContext'
import { productAccessorHasZavaOdsPartner } from '../../model/productAccessor/productAccessorHasZavaOdsPartner'

type ProductPageOdsContextValue = {
  experimentOdsV1Enabled: boolean
  videoConsultation: boolean
}

const ProductPageOdsContext = createContext<ProductPageOdsContextValue | null>(
  null,
)

export const ProductPageOdsProvider: FC<PropsWithChildren> = ({ children }) => {
  const { product } = useProductPageContext()
  const odsVcModalExperiment = useGetExperiment(EXPERIMENT_NAME_ODS_VC_MODAL)

  const value = useMemo((): ProductPageOdsContextValue => {
    return {
      experimentOdsV1Enabled:
        experimentAccessorIsVariantV1(odsVcModalExperiment),
      videoConsultation: !productAccessorHasZavaOdsPartner(product),
    }
  }, [odsVcModalExperiment, product])

  return (
    <ProductPageOdsContext.Provider value={value}>
      {children}
    </ProductPageOdsContext.Provider>
  )
}

export const useProductPageOdsContext = (): ProductPageOdsContextValue => {
  const contextValue = useContext(ProductPageOdsContext)
  if (contextValue === null) {
    throw new Error('useProductPageOdsContext value not initialized')
  }

  return contextValue
}
